import { Component, Input } from '@angular/core';

@Component({
  selector: 'fav-image',
  template: `<ng-container *ngIf="src || srcSet">
    <img [ngClass]="cssClass" src="{{ src }}" srcset="{{ srcSet }}" alt="" loading="lazy" />
  </ng-container>`,
  styleUrls: ['./fav-image.component.scss'],
})
export class FavImageComponent {
  @Input() src: string | undefined;
  @Input() srcSet: string | undefined;
  @Input() cssClass: string;
}
